/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from 'styled-components';
import { Table as MuiTable, TableProps as MuiTableProps, darken, lighten } from '@material-ui/core';
import { Table } from '../../../ui-kit';
import { TableProps } from '../../../ui-kit/Table/Table';
import { enumToPrimaryColorMap } from '../../../utils';
import { Color } from '../../../generated/graphql';

export const TableWithCollapsibleContent = styled(<T, P = any>(props: TableProps<T, P>) => <Table {...props} />)`
    && > .MuiTableBody-root {
        > .MuiTableRow-root {
            ${({ theme }) => `
                background: ${lighten(theme.palette.background.default, 0.4)};
            `}
        }
        > .stripedRow {
            background: #FFFFFF;
        }
    }
` as <T, P = any>(props: TableProps<T, P>) => JSX.Element;

interface StripedNestedTable extends MuiTableProps {
    color?: Color;
    startOdd?: boolean;
}
export const StripedNestedTable = styled(({ startOdd, color, ...props }: StripedNestedTable) => <MuiTable {...props} />)`
    table-layout: fixed;
    width: 100%;
    min-width: 900px;
    .MuiTableBody-root > .MuiTableRow-root {
        background: #FFFFFF;
        /* background: ${darken('#FFFFFF', 0.2)}; */
        ${({ theme, color, startOdd }) => `
            &:nth-child(${startOdd ? 'odd' : 'even'}) {
                .MuiTableCell-root {
                    :first-child {
                        z-index: 1;    
                    }
                    background-color: ${color
        ? lighten(enumToPrimaryColorMap(theme, color), 0.94)
        : lighten(theme.palette.background.default, 0.1)
}
                }
            }
        `}
    }
`;

export const CategoryColorMarker = styled.div<{ color: Color; isChild?: boolean }>`
    ${({ isChild, color, theme }) => `
        background-color: ${enumToPrimaryColorMap(theme, color)};
        width: ${theme.spacing(2)}px;
        min-width: ${theme.spacing(2)}px;
        height: ${theme.spacing(2)}px;
        margin-right: ${theme.spacing(2)}px;
        border-radius: ${isChild ? '50%' : '4px'};
    `}
`;